export const dynamicTextColor = (text, color) => (
  <span style={{ color }}>{text}</span>
);
